<template>

  <div class="sub_nav_btn_group">
    <el-button
      class="sub_nav_btn"
      :class="{ 'sub_nav_btn_active': activeNav === 'nav_number' }"
      @click="goTo('/number', 'nav_number')">{{ $t('okmain.nav_number') }}</el-button>
    <el-button
      class="sub_nav_btn"
      :class="{ 'sub_nav_btn_active': activeNav === 'nav_member' }"
      @click="goTo('/member', 'nav_member')">{{ $t('okmain.nav_member') }}</el-button>
    <el-button
      class="sub_nav_btn"
      type="primary"
      :class="{ 'sub_nav_btn_active': activeNav === 'nav_sig' }"
      @click="goTo('/sig', 'nav_sig')">{{ $t('okmain.nav_sig') }}</el-button>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      activeNav: 'nav_sig', // 默认激活的导航
      lang_default: '中文(简体)',

    }
  },
  mounted() {
    // 初始化时根据当前路由设置激活的导航
    const currentPath = this.$route.path;
    if (currentPath.includes('/number')) {
      this.activeNav = 'nav_number';
    } else if (currentPath.includes('/member')) {
      this.activeNav = 'nav_member';
    } else if (currentPath.includes('/sig')) {
      this.activeNav = 'nav_sig';
    }
  },
  methods: {
    goTo(keyPath, key) {
      // 如果当前激活的导航已经是目标导航，则不进行跳转
      if (this.activeNav === key) {
        return;
      }
      this.activeNav = key; // 更新当前激活的导航
      this.$router.push({ path: keyPath }); // 跳转到对应的路由
    },
  }
}

</script>

<style scoped>
.sub_nav_btn_group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #172237;
  height: 120px;
  border-bottom: 1px solid rgba(255,255,255,0.2);
}
.sub_nav_btn {
  padding: 15px 36px;
  background: #172237;
  border-radius: 8px;
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 31px;
  font-style: normal;
  text-align: center;
  border: none;
}
.sub_nav_btn_active {
  background: linear-gradient( 180deg, #4968ED 0%, #2337D6 100%);
}
.sub_nav_btn:hover {
  background: linear-gradient( 180deg, #4968ED 0%, #2337D6 100%);
  color: #FFFFFF;
}
.sub_nav_btn:focus {
  background: linear-gradient( 180deg, #4968ED 0%, #2337D6 100%);
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/SubNav.vue